import { Col, Row } from "react-bootstrap";

import "./corporate-profile.css";
import { directorList, rogerProfile } from "constants/corporate-profile";
import parse from "html-react-parser";
import { Link } from "react-router-dom";
import BODButton from "./BODButton";
function BoardOfDirectors() {
  return (
    <>
      <div className="container bod-page">
        <h1>
          <span>Corporate</span> Profile
        </h1>

        <BODButton />

        <div style={{ height: "100px" }}></div>

        <Row className="d-flex align-items-center">
          <Col md={5} xs={4}>
            <div className="divider"></div>
          </Col>
          <Col md={2} xs={4}>
            <h2 className="divider-title">Chairman</h2>
          </Col>
          <Col md={5} xs={4}>
            <div className="divider"></div>
          </Col>
        </Row>
        <div style={{ height: "32px" }}></div>

        <Row className="justify-content-center d-flex">
          <Col md={7} xs={12} className="profile-card-mobile">
            <Row className="profile-card align-items-end ">
              <Col md={6}>
                <img src={rogerProfile.image} alt="roger" width={"100%"} />
              </Col>
              <Col md={6}>
                <div className="content">
                  <h1>{rogerProfile.name}</h1>
                  <h2>{rogerProfile.position}</h2>
                  <div style={{ height: "32px" }}></div>
                  <p>
                    {rogerProfile.biography.length < 260
                      ? parse(rogerProfile.biography)
                      : parse(rogerProfile.biography.substring(0, 260))}
                  </p>

                  <Link
                    to="/about/corporate-profile/view-profile"
                    state={{ profile: rogerProfile }}
                  >
                    Read More
                  </Link>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
        <div style={{ height: "80px" }}></div>

        <Row className="d-flex align-items-center">
          <Col md={5} xs={4}>
            <div className="divider"></div>
          </Col>
          <Col md={2} xs={4}>
            <h2 className="divider-title">Directors</h2>
          </Col>
          <Col md={5} xs={4}>
            <div className="divider"></div>
          </Col>
        </Row>

        <div style={{ height: "32px" }}></div>
        <Row className="profile-card-row">
          {directorList.map((item, index) => (
            <Col md={3} className="profile-card mb-4">
              <img src={item.image} alt="roger" width={"100%"} />
              <div className="content-members">
                <h1>{item.name}</h1>
                <h2>{item.position}</h2>
                <div style={{ height: "16px" }}></div>
                <p>
                  {item.biography.length < 120
                    ? parse(item.biography)
                    : parse(item.biography.substring(0, 120) + "...")}
                </p>

                <Link
                  to="/about/corporate-profile/view-profile"
                  state={{ profile: item }}
                >
                  Read More
                </Link>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </>
  );
}

export default BoardOfDirectors;
